<template>
  <div class="lighten-3 pa-2 leaflet-slider-wrapper" style="position:relative">
    <swiper :options="swiperOptions" style="padding:20px 0 40px">
      <swiper-slide v-for="leaflet in leaflets" :key="leaflet.leafletId">
        <div class="leaflet-descr py-4">
          <h3 class="mt-1 mt-sm-2 mt-md-0">{{ leaflet.title }}</h3>
        </div>
        <!-- <v-card
          class="rounded-0 leaflet-slider-card"
          :to="{
            name: 'Leaflet',
            params: {
              leafletId: leaflet.leafletId.toString()
            }
          }"
        >
          <img
            :src="`${leaflet.baseLocation}${leaflet.firstPagePreview}`"
            onerror="this.onerror=null;this.src='/no-icon.png'"
          />
        </v-card> -->
        <LeafletCard :leaflet="leaflet" />
      </swiper-slide>
    </swiper>
    <div class="swiper-button-next">
      <v-icon color="primary">icon-arrow-forward</v-icon>
    </div>
    <div class="swiper-button-prev">
      <v-icon color="primary">icon-arrow-back</v-icon>
    </div>
  </div>
</template>
<style lang="scss">
.leaflets-container {
  .swiper-button-next::after,
  .swiper-button-prev::after {
    display: none;
  }
}
.leaflet-slider-wrapper {
  .leaflet-descr {
    height: 30px;
    display: block;
    white-space: nowrap;
  }
  .swiper-slide {
    width: fit-content;
    .leaflet-card {
      border-radius: 8px !important;
      height: 100%;
      width: 267px;
      .v-image__image {
        border-radius: 8px !important;
      }
    }
  }
}
// .leaflets-container {
//   .leaflet-slider-card {
//     border-radius: 8px !important;
//     height: 300px;
//     img {
//       border-radius: 8px !important;
//       height: 100%;
//       width: auto;
//     }
//   }
// }
.leaflet-slider-card {
  background-color: transparent !important;
}
.leaflet-descr {
  @media #{map-get($display-breakpoints, 'sm-and-down')} {
    text-align: center;
  }
  h3 {
    color: $secondary;
  }
}
@media #{map-get($display-breakpoints, 'sm-and-down')} {
  .leaflet-descr {
    h3 {
      line-height: 1.7rem !important;
      // height: 75px;
    }
  }
}
</style>
<script>
// import leafletService from "~/service/leafletService.js";

import LeafletCard from "@/components/leaflet/LeafletCard.vue";

export default {
  name: "LeafletsSlider",
  data() {
    return {
      swiperOptions: {
        slidesPerView: "auto",
        spaceBetween: 20,
        autoplay: true,
        watchOverflow: true,
        loop: false,
        navigation: {
          prevEl: `.swiper-button-prev`,
          nextEl: `.swiper-button-next`
        }
      }
    };
  },
  components: { LeafletCard },

  props: {
    parentWarehouseId: { type: Number, required: false },
    parentLeafletTypeId: { type: Number, required: true },
    leaflets: { type: Array, required: true }
  },
  methods: {},
  async mounted() {}
};
</script>
